// TODO: 複数跨ぐ共通処理系はここに寄せたい

import { SequenceStepInstanceAllOfStatusEnum } from '@/api/openapi';
import { TFormDirectMailSequenceStep, TFormSequenceStep, TStepType } from '@/components/organisms/user/general/sequence/types';
import { getStepTypeByActionType } from '@/composable/user/sequence/post-put-body';

const REPLY_PREFIX = 'Re:';

// -- step

const makeSubjectForReplyInThread = (previousStep: TFormDirectMailSequenceStep | undefined): string => {
  const previousSubject = previousStep?.subject;
  return previousSubject?.startsWith(REPLY_PREFIX) ? previousSubject : `${REPLY_PREFIX} ${previousSubject}`;
};
const makeSubjectForNewMail = (currentStep: TFormDirectMailSequenceStep): string => {
  const subject = currentStep.subject;
  // NOTE: 頭の「Re: 」だけ除く
  return subject.startsWith(REPLY_PREFIX) ? subject.replace(new RegExp(`^${REPLY_PREFIX} `), '') : subject;
};

// -- steps

const findPreviousStep = <T extends TFormSequenceStep>(steps: TFormSequenceStep[], currentStep: TFormSequenceStep, stepType?: TStepType): T | undefined => {
  const targetSteps = filterStepsByType(steps, stepType);
  return targetSteps.filter((step) => step.sortOrder < currentStep.sortOrder && step.status !== SequenceStepInstanceAllOfStatusEnum.Skipped).at(-1) as T | undefined;
};
const findNextStep = <T extends TFormSequenceStep>(steps: TFormSequenceStep[], currentStep: TFormSequenceStep, stepType?: TStepType): T | undefined => {
  const targetSteps = filterStepsByType(steps, stepType);
  return targetSteps.find((step) => step.sortOrder > currentStep.sortOrder) as T | undefined;
};
const filterStepsByType = (steps: TFormSequenceStep[], stepType?: TStepType): TFormSequenceStep[] => {
  return stepType != null ? steps.filter((step) => getStepTypeByActionType(step.actionType) === stepType) : steps;
};
const findMailThreadRootStep = <T extends TFormSequenceStep>(steps: TFormSequenceStep[], currentStep: TFormSequenceStep): T | undefined => {
  if (!currentStep.replyInThread) return undefined;
  const targetSteps = filterStepsByType(steps, 'direct_mail');
  return targetSteps.filter((step) => step.sortOrder < currentStep.sortOrder && !step.replyInThread).at(-1) as T | undefined;
};
const findStepByDirectMailId = (steps: TFormSequenceStep[], directMailId: number): TFormSequenceStep | undefined => {
  return steps.find((step) => 'directMailId' in step && step.directMailId === directMailId);
};

export {
  makeSubjectForReplyInThread,
  makeSubjectForNewMail,
  findPreviousStep,
  findNextStep,
  findMailThreadRootStep,
  findStepByDirectMailId,
};
